// extracted by mini-css-extract-plugin
export default {"container":"Toggle_container__MOj3i","float_right":"Toggle_float_right__5BZyb"};